import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=720f9680&"
import script from "./Index.js?vue&type=script&lang=js&"
export * from "./Index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports